import './styles/job-family-list.scss'

import React      from 'react'
import PropTypes  from 'prop-types'

import JobItem from './JobItem'

export default class JobFamilyList extends React.Component {
  static propTypes = {
    title:   PropTypes.string.isRequired,
    jobs:    PropTypes.array,
    history: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
  }

  render() {
    const { title, jobs, history, onClick } = this.props

    if (!jobs || jobs.length === 0) {
      return null
    }

    return (
      <div className="job-family-list">
        <div className="title">{ title }</div>

        <div className="job-family-scrollable-content">
          {
            jobs.map((job) => {
              const handleClick = () => onClick(job)

              return (
                <div className="job-item" key={job.id} onClick={handleClick}>
                  <JobItem item={job} history={history} />
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}
